import { createContext, useContext } from "react";

const TicketContext = createContext<{
  checkLogin: boolean;
  setCheckLogin: (x: boolean) => void;
}>({ checkLogin: false, setCheckLogin: () => true });

export { TicketContext, useContext };
